import * as React from "react"
import { CascaderAjaxSeeker } from "@ui-seeker/core"

import { WEBBACK_V2_API } from "@constants"
import { googleCategory } from "@signals"


export default function DIPGoogleCategories({ ...props }) {
    return <CascaderAjaxSeeker
		multiple
		urlAjax={`${WEBBACK_V2_API}/master-data/google-categories/options`}
		label="Category"
		value={googleCategory.value}
		placeholder="All categories"
		onChange={newValue => googleCategory.value = newValue}
        menuWidth={300}
		placement="bottomStart"
		{...props}
	/>
}